import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { PATHS } from './paths';

import { useAuthStatus } from '@/shared/hooks/useAuthStatus';

interface ProtectedRouteProps {
    children: ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const { isLoggedIn } = useAuthStatus();

    if (!isLoggedIn) {
        return <Navigate to={PATHS.HOME} replace />;
    }

    return <>{children}</>;
};
